import { LitElement, html, css } from 'lit-all'
import styles from 'lib-styles'
import { formatPrice, t } from 'lib-utils'

class NovaFreeShippingThreshold extends LitElement {
  static properties = {
    threshold: { type: Number },
    cartSubtotal: { type: Number, state: true },
    cartLoading: { type: Boolean, state: true },
    percentageValue: { type: Number, state: true }
  }

  constructor() {
    super()
    this.cartLoading = true
    document.addEventListener('nova:changeQuantityFinished', this._handleUpdateProgressBar)
    this._asyncUpdateCart()
  }

  _asyncUpdateCart = async () => {
    this.cartLoading = true
    try {
      const response = await fetch('/cart.js')
      if (!response.ok) {
        throw new Error('Error fetching cart')
      }
      const data = await response.json()
      this.cartSubtotal = data.items_subtotal_price / 100
      // Compute percentageValue as a number (remove any percent sign)
      this.percentageValue = this.threshold > 0 ? Math.min((this.cartSubtotal / this.threshold) * 100, 100) : 0
    } catch (err) {
      console.error('Error fetching cart', err)
    } finally {
      this.cartLoading = false
    }
  }

  _handleUpdateProgressBar = () => {
    setTimeout(() => {
      this._asyncUpdateCart()
    }, 1000)
  }

  _calculateRemaining() {
    return formatPrice((this.threshold - this.cartSubtotal) * 100)
  }

  _displayMessage() {
    let message
    if (this.cartSubtotal >= this.threshold) {
      message = `${t('cart.free_shipping_bar.free_shipping_message')}`
    } else {
      message = html`Add <span style="font-weight: 600">${this._calculateRemaining()}</span> ${t("cart.free_shipping_bar.amount_remaining_message")}`
    }

    return message
  }

  render() {
    return html`
     <div class="nova-free-shipping-threshold__wrapper">
      <p>${this._displayMessage()}</p>
      <sl-progress-bar value="${this.percentageValue}"></sl-progress-bar>
    </div>
    `
  }

  static styles = [
    styles.flex,
    css`
      :host {
        display: block;
        padding: 8px  var(--nova-space-sm) 0 var(--nova-space-sm); ;
        border-radius: 5px; 
      }
.nova-free-shipping-threshold__wrapper {        border-radius: 5px;background: var(--nova-brand-light);

  padding: var(--nova-space-md) var(--nova-space-md);
  }
      p {
        font-size: 16px;
        line-height: 130%;
        margin: 0;
        margin-bottom: 8px;
        color: var(--nova-brand-text);
        font-weight:500;

      }
p span {
        color: var(--nova-brand-primary);
}
      sl-progress-bar {
        --height:6px;
        border-radius: 5px;
      }

      @media screen and (min-width: 768px) {
        :host {
          padding:  16px 12px 8px;
        }

        p {
          font-size: 16px;
          font-weight:500;
        }
      }
    `
  ]
}

customElements.define('nova-free-shipping-threshold', NovaFreeShippingThreshold)